export default {
  visibilityButtonTitle: 'Change password visibility',
};
